// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#EchartS1{position:absolute;top:60%;width:30%;height:40%;background-color:#17293d;box-sizing:border-box}", ""]);
// Exports
module.exports = exports;
